import React, { useState, useEffect } from "react";
import "./index.scss";
import axiosInstance from "../../../../services/api/API";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import viewIcon from "../../../../../Assets/icons/eye 1.svg";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";
// Un-Checkbox.svg
const JobCardInvoicesList = () => {
  const [jobCardInvoiceData, setJobCarInvoiceData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const token = localStorage.getItem("authToken");
  const [totalRecords, setTotalRecored] = useState(0);
  const [totalInvoiceList, setTotalInvoiceList] = useState(null);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [filters, setFilters] = useState({});
  const [lodertable, setLoaderTable] = useState(false);
  
  const navigate = useNavigate();

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardInvoiceList(newPage);
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // const formatDataForDownload = (data, headers, keyMapping) => {
  //   const csvHeaders = headers.map((header) => keyMapping[header]);
  //   const csvRows = data.map((item) => {
  //     return headers
  //       .map((header) => {
  //         const key = keyMapping[header];
  //         return item[key];
  //       })
  //       .join(",");
  //   });
  //   const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
  //   return csvContent;
  // };

  const handleEdit = (rowData) => {
    navigate("job-invoice-details", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const fetchJobCardInvoiceList = async (page = 0, pageSize = 1) => {
    const allfilteredData = filters;
    const payload = {
      business_partner_id: 1,
      orderBy: "job_card_id desc",
      page,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.toDate ? allfilteredData?.toDate : "",
      pageSize,
      SearchText: searchTerm,
    };
    try {
      setLoaderTable(true);
      const response = await axiosInstance.post(
        "/jobcardinvoice/list",
        payload,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoaderTable(false);
      const formattedData = response.data.data.data?.map((item, index) => ({
        ...item,
        Sr_No: index + 1,
        status: item?.solved === 0 ? "Pending" : "Done",
        // job_card_no:onClickNavigetion(item),
      }));
      setJobCarInvoiceData(formattedData);
      setTotalRecored(response?.data?.data?.totalRecords);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
      setTotalInvoiceList(response?.data?.data);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const Job_Card_TABLE_HEADERS = [
    "Job Card No.",
    "Customer Name",
    "Job Type",
    "Supervisor Name",
    "Product",
    "Make",
    "Model",
    "Variant",
    "Color",
    "Action",
  ];

  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Job Card No.": "job_card_no",
    "Customer Name": "customer_name",
    "Job Type": "job_type",
    "Supervisor Name": "supervisor_name",
    Product: "product_name",
    Make: "make_name",
    Model: "model_name",
    Variant: "variant_name",
    Color: "color_name",
    Action: [
      {
        type: "edit",
        icon: editIcon,
        label: "Edit",
      },
      {
        type: "view",
        icon: viewIcon,
        label: "View",
      },
    ],
  };

  useEffect(() => {
    fetchJobCardInvoiceList();
  }, []);

  useEffect(() => {
    fetchJobCardInvoiceList();
  }, [filters]);

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchJobCardInvoiceList();
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-4",
    },
  ];

  const handleSearch = () => {
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
    });
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div className="OnboardManagamentbuttonContainer col-md-4  mt-2 mb-2">
          <h5 style={{fontWeight:"600"}} >Job Card Invoice</h5>
        </div>
        <div className=" col-md-8 mt-2 mb-2 totalvaluescontainer ">
          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              &#8377;{totalInvoiceList?.total || 0}
            </div>
            <div>Total Invoice</div>
          </div>

          <div className="topleftdataContainer">
            <div className="listTopDataValueText">
              &#8377;{totalInvoiceList?.total_pending || 0}
            </div>
            <div>Invoice Pending</div>
          </div>
          <div
            // key={}
            className="topleftdataContainer"
          >
            <div className="listTopDataValueText">
              &#8377;{totalInvoiceList?.total_paid || 0}
            </div>
            <div>Invoice Paid</div>
          </div>
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView">
          <div className="filterLeftView pt-4 col-md-4 gap-2">
            <h5 style={{fontWeight:"600"}}>Job Card Invoice List</h5>
            <div className="searchinput-wrapper">
              <input
                type="text"
                className="searchinput"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchInputChange}
              />
              {/* <img src={searchIcon} alt="Search" className="searchinput-icon" />  */}
            </div>
          </div>
          <div className="filterRightView col-md-8 gap-2">
            <h5 style={{paddingTop:"30px"}} >Filter By</h5>
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
              // onSubmit={handleFormSubmit}
            />
          </div>
        </div>
        <CustomTable
          data={jobCardInvoiceData || []}
          headers={Job_Card_TABLE_HEADERS}
          keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
          onEdit={handleEdit} // Pass the handleEdit function
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          totalRecords={totalRecords}
          handleViewButton={handleEdit}
          tableLoaderShow={lodertable}
        />
      </div>
    </div>
  );
};

export default JobCardInvoicesList;
